export const root = "/";
export const home = "/home";
export const aboutMe = "/aboutMe";
export const skills = "/skills";
export const contact = "/contact";
